export const AUTH_USER = 'AUTH_USER';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export const VIEW_ERROR_MESSAGE = 'VIEW_ERROR_MESSAGE';
export const SET_CODE_VERIFIER = 'SET_CODE_VERIFIER';
export const SET_AUTH_STATE = 'SET_AUTH_STATE';

export const MEDICATION_SUCCESS = 'MEDICATION_SUCCESS';
export const MEDICATION_ERROR = 'MEDICATION_ERROR';
export const MEDICATION_LOADING = 'MEDICATION_LOADING';

export const CONFIG_SUCCESS = 'CONFIG_SUCCESS';
export const CONFIG_ERROR = 'CONFIG_ERROR';
export const CONFIG_LOADING = 'CONFIG_LOADING';

export const MESSAGES_SUCCESS = 'MESSAGES_SUCCESS';
export const MESSAGES_ERROR = 'MESSAGES_ERROR';
export const MESSAGES_LOADING = 'MESSAGES_LOADING';
export const MESSAGES_REMOVE_ALERT = 'MESSAGES_REMOVE_ALERT';

export const ORDER_HISTORY_SUCCESS = 'ORDER_HISTORY_SUCCESS';
export const ORDER_HISTORY_ERROR = 'ORDER_HISTORY_ERROR';
export const ORDER_HISTORY_LOADING = 'ORDER_HISTORY_LOADING';

export const ADDRESSES_SUCCESS = 'ADDRESS_SUCCESS';
export const ADDRESSES_ERROR = 'ADDRESS_ERROR';
export const ADDRESSES_LOADING = 'ADDRESS_LOADING';

export const MANUAL_ORDERS_SUCCESS = 'MANUAL_ORDERS_SUCCESS';
export const MANUAL_ORDERS_ERROR = 'MANUAL_ORDERS_ERROR';
export const MANUAL_ORDERS_LOADING = 'MANUAL_ORDERS_LOADING';
export const START_MANUAL_JOURNEY = 'START_MANUAL_JOURNEY';
export const SET_SELECTED_MANUAL_ORDER = 'SET_SELECTED_MANUAL_ORDER';
export const SET_MANUAL_PAYMENT = 'SET_MANUAL_PAYMENT';
export const MANUAL_ORDERS_CLEAR = 'MANUAL_ORDERS_CLEAR';

export const ADDRESS_SET = 'ADDRESS_SET';
export const ODS_SET = 'ODS_SET';
export const OFFBOARDING_PHARMACY_MESSAGE_SET = 'OFFBOARDING_PHARMACY_MESSAGE_SET';

export const EDIT_ADDRESS_SET = 'EDIT_ADDRESS_SET';
export const EDIT_ADDRESS_CLEAR = 'EDIT_ADDRESS_CLEAR';

export const GP_SET = 'GP_SET';

export const BASKET_ITEM_ADD = 'BASKET_ITEM_ADD';
export const BASKET_ITEM_REMOVE = 'BASKET_ITEM_REMOVE';
export const BASKET_CLEAR = 'BASKET_CLEAR';

export const DELIVERY_METHOD_SET = 'DELIVERY_METHOD_SET';
export const PAYMENT_SET = 'PAYMENT_SET';
export const CLEAR_PAYMENT_AND_EXEMPTION = 'CLEAR_PAYMENT_AND_EXEMPTION';

export const SET_PATIENT_INFO = 'SET_PATIENT_INFO';
export const SET_IS_P9 = 'SET_IS_P9';
export const SET_PATIENT_TYPE = 'SET_PATIENT_TYPE';

export const PREPOPULATE_ADDRESS = 'PREPOPULATE_ADDRESS';

export const PHARMACY_LIST = 'PHARMACY_LIST';

export const SET_ADD_MEDICATION = 'SET_ADD_MEDICATION';

export const REMOVE_PREPOPULATED_ADDRESS = 'REMOVE_PREPOPULATED_ADDRESS';

export const ADD_EXEMPTION = 'ADD_EXEMPTION';

export const START_PAYMENT_JOURNEY = 'START_PAYMENT_JOURNEY';

export const SELECTED_PHARMACY_DETAILS_SET = 'SELECTED_PHARMACY_DETAILS_SET';

export const GP_REGISTERED_IN_RANGE_SET = 'GP_REGISTERED_IN_RANGE_SET';

export const PHARMACIES_IN_RANGE_SET = 'PHARMACIES_IN_RANGE_SET';
